import testimonialWilliam from "@/assets/testimonial-william.jpg";
import testimonialSarah from "@/assets/testimonial-sarah.jpg";
import testimonialSamantha from "@/assets/testimonial-samantha.jpg";
import { ChevronLeft, ChevronRight } from "lucide-react";

const internshipTestimonials = [
  {
    avatar: testimonialWilliam,
    name: "William H.",
    quote:
      "I needed a phone plan anyway, but with Perch it actually feels like I'm getting something back from my payments.",
  },
  {
    avatar: testimonialSarah,
    name: "Sarah L.",
    quote:
      "Finally a company that gets it. Simple plans, solid coverage, and tools that actually help you move forward financially.",
  },
  {
    avatar: testimonialSamantha,
    name: "Samantha W.",
    quote:
      "Switched from a major carrier. Same coverage, better experience—and now my payments actually feel like they matter.",
  },
];

const InternshipTestimonials = () => {
  return (
    <section style={{ background: "#27243A" }}>
      <div className="max-w-[1514px] w-full mx-auto px-4 md:px-8 lg:px-[76px] py-20 lg:py-24">
        <span
          className="inline-flex items-center justify-center rounded-[9px]"
          style={{
            width: "104px",
            height: "41px",
            background: "#533DDA",
            color: "#FFFFFF",
            fontFamily: "Inter, sans-serif",
            fontWeight: 500,
            fontSize: "14px",
            letterSpacing: "-0.05em",
          }}
        >
          Testimonials
        </span>

        <h2
          className="mt-6"
          style={{
            fontFamily: "Instrument Sans, sans-serif",
            fontWeight: 600,
            fontSize: "55px",
            lineHeight: "74px",
            letterSpacing: "-0.05em",
            color: "#FFFFFF",
          }}
        >
          Hear how people are getting more from their phone plan.
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {internshipTestimonials.map((t, i) => (
            <div
              key={i}
              className="relative rounded-[20px] p-8 pt-10 flex flex-col justify-between overflow-hidden"
              style={{
                maxWidth: "435px",
                height: "510px",
                background: "linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%)",
              }}
            >
              <div
                className="absolute inset-0 rounded-[20px] pointer-events-none"
                style={{
                  padding: "0.5px",
                  background: "linear-gradient(98.15deg, #FFFFFF 62.94%, #A4A4A4 99.21%)",
                  WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                  WebkitMaskComposite: "xor",
                  maskComposite: "exclude",
                }}
              />

              <div className="relative z-10">
                <div className="flex items-start justify-between mb-8">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="rounded-full"
                    style={{ width: "105px", height: "104px" }}
                    loading="lazy"
                    decoding="async"
                  />
                  <span
                    style={{
                      fontFamily: "Georgia, serif",
                      fontSize: "160px",
                      lineHeight: "90px",
                      color: "#FFFFFF1A",
                      fontWeight: 400,
                      userSelect: "none",
                    }}
                  >
                    &#x201C;
                  </span>
                </div>

                <p
                  style={{
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 500,
                    fontSize: "23px",
                    lineHeight: "44px",
                    letterSpacing: "-0.05em",
                    color: "#FFFFFF",
                  }}
                >
                  {t.quote}
                </p>
              </div>

              <p
                style={{
                  fontFamily: "'Dancing Script', cursive",
                  fontSize: "23px",
                  lineHeight: "44px",
                  letterSpacing: "-0.05em",
                  color: "#FFFFFF",
                  fontWeight: 400,
                  marginTop: "auto",
                  paddingTop: "24px",
                }}
              >
                {t.name}
              </p>
            </div>
          ))}
        </div>

        <div className="flex justify-end mt-8 gap-3">
          <button
            className="rounded-full flex items-center justify-center transition-colors hover:bg-white/10"
            style={{
              width: "52px",
              height: "52px",
              border: "1px solid #FFFFFF40",
              background: "transparent",
            }}
          >
            <ChevronLeft className="w-5 h-5 text-white" />
          </button>
          <button
            className="rounded-full flex items-center justify-center transition-colors hover:bg-white/10"
            style={{
              width: "52px",
              height: "52px",
              border: "1px solid #FFFFFF40",
              background: "transparent",
            }}
          >
            <ChevronRight className="w-5 h-5 text-white" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default InternshipTestimonials;
